import { Auth } from "aws-amplify";
import { MatchLogic } from "../components/ProtectedRoute/ProtectedRoute";
import { Role } from "../constants/roles";

export async function userHasRoles(requiredRoles: Role[], matchLogic: MatchLogic): Promise<boolean> {
  try {
    const userRoles: Role[] = await getRoles();

    return matchLogic === MatchLogic.AND ? requiredRoles.every(role => userRoles.includes(role)) : requiredRoles.some(role => userRoles.includes(role));

  } catch (error) {
    console.error({error})
    // default to false if there's any issue getting the roles
    return false;
  }
}

export async function getRoles(): Promise<Role[]> {
  try {
    const userInfo = await Auth.currentUserPoolUser();
    const userRoles: Role[] = userInfo.signInUserSession.accessToken.payload['cognito:groups'];

    return userRoles || [];
  } catch (error) {
    // default to false if there's any issue getting the roles
    return [];
  }
}
